import { connect } from "react-redux";
import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";
import WizardForm from "../../../common/wizardForm";
import EnterpriseDetailsForm from "./EnterpriseDetailsForm";
import EnterpriseLicenseForm from "./EnterpriseLicenseForm";
import { convertSize } from "../../../../helpers/DisplayHelper";
import { createRequest } from "../../../../store/slices/enterpriseSlice";
import dayjs from "dayjs";
import CustomBreadCrumbs from "../../../common/breadcrumbs";

const EnterpriseAdd = ({
  labels,
  parent,
  createEnterprise,
  action,
  error,
  requesting,
}) => {
  const intl = useIntl();
  const navigate = useNavigate();
  const [logoFile, setLogoFile] = useState(null);

  useEffect(() => {
    if (action === "create" && !requesting && !error) {
      navigate(parent.to);
    }
  }, [action, error, requesting, navigate, parent.to]);

  const wizardItem = [
    {
      label: intl.formatMessage({ id: "basic_info" }),
      Component: EnterpriseDetailsForm,
    },
    {
      label: intl.formatMessage({ id: "enterprise_license" }),
      Component: EnterpriseLicenseForm,
    },
  ];

  const onLogoSelect = (file) => {
    setLogoFile(file);
  };

  const onSubmit = (values) => {
    const payload = {
      ...values,
      logo: null,
      subDomain: values.subDomain.toLowerCase(),
      license: {
        ...values.license,
        startDate: dayjs(values.license.startDate).format("YYYY-MM-DD"),
        endDate: dayjs(values.license.endDate).format("YYYY-MM-DD"),
      },
      additionalUrls: "",
      entitlements: values.entitlements.map((item, index) => ({
        value:
          index === 1
            ? convertSize(parseInt(item.value), "GB", "B") + ""
            : item.value,
        type: index + 1,
      })),
    };

    delete payload.logo;

    createEnterprise({
      data: payload,
      logo: logoFile,
    });
  };

  return (
    <div>
      <CustomBreadCrumbs labels={labels} navigate={navigate} />
      <div className="edexlms-page-content">
        <div className="edexlms-page-header">
          <div className="edexlms-page-title">
            <span
              className="pi pi-arrow-left mr-2 cursor-pointer"
              onClick={(e) => navigate(parent.to)}
            ></span>
            {intl.formatMessage({ id: "add_enterprise" })}
          </div>
        </div>
      </div>
      <div className="edexlms-page-body">
        <WizardForm
          steps={wizardItem}
          onWizardSubmit={onSubmit}
          onCancel={() => navigate(parent.to)}
          formOtherProps={{
            onLogoSelect,
            action,
            error,
            requesting,
          }}
        />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  action: state.enterprises.action,
  error: state.enterprises.error,
  requesting: state.enterprises.requesting,
});

const mapDispatchToProps = (dispatch) => ({
  createEnterprise: (data) => dispatch(createRequest(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EnterpriseAdd);
